appHost.actions.register({
    // #region Vars
    name: '288a.system.account.select',
    // #endregion
    // #region Entry
    async execute(data, params) {
        return this.Window(await appHost.notification.showModal2(appHost.components.getComponent('g-ecommerce__account-select-dialog')));
    },
    // #endregion
});
export {};
